"use client"
import { useEffect, useState } from "react";

const useSticky = () => {
    const [sticky, setSticky] = useState(false);

    useEffect(() => {
        let ticking = false;

        const stickyHeader = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    setSticky(window.scrollY > 80);
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', stickyHeader, { passive: true });

        return () => {
            window.removeEventListener('scroll', stickyHeader);
        };
    }, []);

    return {
        sticky,
    }
}

export default useSticky;